export const ActionTypes = {

    // Authentication
    SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
    SIGNIN_FAIL: "SIGNIN_FAIL",
    SIGN_OUT: "SIGN_OUT",
    SIGNUP_FAIL: "SIGNUP_FAIL",
    SOCIAL_AUTH_SUCCESS: "SOCIAL_AUTH_SUCCESS",
    SOCIAL_AUTH_FAIL: "SOCIAL_AUTH_FAIL",
    FORGET_PASSWORD: "FORGET_PASSWORD",
    RESET_PASSWORD: "RESET_PASSWORD",
    EMAIL_ACTIVATION: "EMAIL_ACTIVATION",

    // Data
    SET_COUNTRIES: "SET_COUNTRIES",

    SET_SECTORS: "SET_SECTORS",
    ADD_SECTORS: "ADD_SECTORS",
    UPDATE_SECTORS: "UPDATE_SECTOR",
    DELETE_SECTORS: "DELETE_SECTOR",

    SET_STATUTORY_INDUSTRY: "SET_STATUTORY_INDUSTRY",
    ADD_STATUTORY_INDUSTRY: "ADD_STATUTORY_INDUSTRY",
    UPDATE_STATUTORY_INDUSTRY: "UPDATE_STATUTORY_INDUSTRY",
    DELETE_STATUTORY_INDUSTRY: "DELETE_STATUTORY_INDUSTRY",

    SET_PHASES: "SET_PHASES",
    ADD_PHASES: "ADD_PHASES",
    UPDATE_PHASES: "UPDATE_PHASES",
    DELETE_PHASES: "DELETE_PHASES",

    SET_ORGANISATIONS: "SET_ORGANISATIONS",
    ADD_ORGANISATIONS: "ADD_ORGANISATIONS",
    UPDATE_ORGANISATIONS: "UPDATE_ORGANISATIONS",
    DELETE_ORGANISATIONS: "DELETE_ORGANISATIONS",

    SET_COMPETENCIES_SCORE: "SET_COMPETENCIES_SCORE",
    ADD_COMPETENCIES_SCORE: "ADD_COMPETENCIES_SCORE",
    UPDATE_COMPETENCIES_SCORE: "UPDATE_COMPETENCIES_SCORE",
    DELETE_COMPETENCIES_SCORE: "DELETE_COMPETENCIES_SCORE",

    SET_PERSONAL_SKILLS: "SET_PERSONAL_SKILLS",
    ADD_PERSONAL_SKILLS: "ADD_PERSONAL_SKILLS",
    UPDATE_PERSONAL_SKILLS: "UPDATE_PERSONAL_SKILLS",
    DELETE_PERSONAL_SKILLS: "DELETE_PERSONAL_SKILLS",

    SET_QUALIFICATIONS: "SET_QUALIFICATIONS",
    ADD_QUALIFICATIONS: "ADD_QUALIFICATIONS",
    UPDATE_QUALIFICATIONS: "UPDATE_QUALIFICATIONS",
    DELETE_QUALIFICATIONS: "DELETE_QUALIFICATIONS",

    SET_EDUCATIONS: "SET_EDUCATIONS",
    ADD_EDUCATIONS: "ADD_EDUCATIONS",
    UPDATE_EDUCATIONS: "UPDATE_EDUCATIONS",
    DELETE_EDUCATIONS: "DELETE_EDUCATIONS",

    SET_FUNCTIONS: "SET_FUNCTIONS",
    ADD_FUNCTIONS: "ADD_FUNCTIONS",
    UPDATE_FUNCTIONS: "UPDATE_FUNCTIONS",
    DELETE_FUNCTIONS: "DELETE_FUNCTIONS",

    SET_CATEGORYS: "SET_CATEGORYS",
    ADD_CATEGORYS: "ADD_CATEGORYS",
    UPDATE_CATEGORYS: "UPDATE_CATEGORYS",
    DELETE_CATEGORYS: "DELETE_CATEGORYS",

    SET_JOB_TITLES: "SET_JOB_TITLES",
    ADD_JOB_TITLES: "ADD_JOB_TITLES",
    UPDATE_JOB_TITLES: "UPDATE_JOB_TITLES",
    DELETE_JOB_TITLES: "DELETE_JOB_TITLES",

    SET_GRADE: "SET_GRADE",
    ADD_GRADE: "ADD_GRADE",
    UPDATE_GRADE: "UPDATE_GRADE",
    DELETE_GRADE: "DELETE_GRADE",

    SET_REGION: "SET_REGION",
    ADD_REGION: "ADD_REGION",
    UPDATE_REGION: "UPDATE_REGION",
    DELETE_REGION: "DELETE_REGION",

    SET_SYSTEMS: "SET_SYSTEMS",
    ADD_SYSTEMS: "ADD_SYSTEMS",
    UPDATE_SYSTEMS: "UPDATE_SYSTEMS",
    DELETE_SYSTEMS: "DELETE_SYSTEMS",

    SET_SYSTEM_EXPEREINCE: "SET_SYSTEM_EXPEREINCE",
    ADD_SYSTEM_EXPEREINCE: "ADD_SYSTEM_EXPEREINCE",
    UPDATE_SYSTEM_EXPEREINCE: "UPDATE_SYSTEM_EXPEREINCE",
    DELETE_SYSTEM_EXPEREINCE: "DELETE_SYSTEM_EXPEREINCE",

    SET_SYSTEM_EXPEREINCE_SCORING: "SET_SYSTEM_EXPEREINCE_SCORING",
    ADD_SYSTEM_EXPEREINCE_SCORING: "ADD_SYSTEM_EXPEREINCE_SCORING",
    UPDATE_SYSTEM_EXPEREINCE_SCORING: "UPDATE_SYSTEM_EXPEREINCE_SCORING",
    DELETE_SYSTEM_EXPEREINCE_SCORING: "DELETE_SYSTEM_EXPEREINCE_SCORING",

    // Dashboard
    SET_DASHBOARD: "SET_DASHBOARD",

    // My Profile
    SET_USER: "SET_USER",
    SET_PROFILE: "SET_PROFILE",
    // CLEAR_PROFILE: "CLEAR_PROFILE",

    // My Analytics
    SET_ANALYTICS: "SET_ANALYTICS",

    // My Network
    // Grow Your Contacts
    SET_YOUR_PROFESSION_PEERS: "SET_YOUR_PROFESSION_PEERS",

    // Suggested Contacts
    SET_SUGGESTED_CONTACTS: "SET_SUGGESTED_CONTACTS",

    // Connection Request
    SET_ACCEPT_CONNECTION_REQUESTS: "SET_ACCEPT_CONNECTION_REQUESTS",

    // Pending Connection Requests
    SET_PENDING_CONNECTION_REQUESTS: "SET_PENDING_CONNECTION_REQUESTS",

    // Connection Request
    SET_ACCEPT_PROFILE_CONNECTION: "SET_ACCEPT_PROFILE_CONNECTION",

    // Profile Pending Connection Requests
    SET_PENDING_PROFILE_REQUESTS: "SET_PENDING_PROFILE_REQUESTS",

    // My Contacts
    SET_MY_CONTACTS: "SET_MY_CONTACTS",

    // Location Map
    SET_LOCATION_MAP: "SET_LOCATION_MAP",

    // User Contact
    SET_CONTACT: "SET_CONTACT",

    //  Connections
    //  1. Send Connection Request
    //  2. Accept Connection Request
    //  3. Withdraw Connection 
    //  4. Cancel Connection Request
    ADD_PENDING_REQUEST: "ADD_PENDING_REQUEST",
    REMOVE_PROFESSION_CONNECTION: "REMOVE_PROFESSION_CONNECTION",
    REMOVE_SUGGESTION_CONNECTION: "REMOVE_SUGGESTION_CONNECTION",

    ADD_SUGGESTION_CONTACT: "ADD_SUGGESTION_CONTACT",
    REMOVE_PENDING_CONNECTION: "REMOVE_PENDING_CONNECTION",

    REMOVE_ACCEPT_REQUEST: "REMOVE_ACCEPT_REQUEST",
    ADD_MY_CONNECTION: "ADD_MY_CONNECTION",


    //  Profile Connection
    //  1. Send Profile 
    //  2. Send Profile Connection Request
    //  3. Accept Profile Connection Request
    //  4. Cancel Profile Connection Request

    REMOVE_PENDING_PROFILE_CONNECTION: "REMOVE_PENDING_PROFILE_CONNECTION",
    ADD_MY_PROFILE_CONNECTION: "ADD_MY_PROFILE_CONNECTION",
    REMOVE_ACCEPT_PROFILE_CONNECTION: "REMOVE_ACCEPT_PROFILE_CONNECTION",

    // References
    //  1. Request a reference 
    //  2. Decline a reference
    //  3. Accept a reference
    SET_REQUESTED_REFERENCE: "SET_REQUESTED_REFERENCE",
    REMOVE_REQUESTED_REFERENCE: "REMOVE_REQUESTED_REFERENCE",
    SET_MY_REFERENCES: "SET_MY_REFERENCES",
    UPDATE_REQUEST_REFERENCE: "UPDATE_REQUEST_REFERENCE",

    // My Connections & My Profile Connections
    SET_MY_CONNECTIONS: "SET_MY_CONNECTIONS",
    SET_PROFILE_CONNECTIONS: "SET_PROFILE_CONNECTIONS",

    // My Performance
    SET_PERFORMANCE: "SET_PERFORMANCE",

    // My Notifications
    SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
    ADD_NOTIFICATIONS: "ADD_NOTIFICATIONS",
    DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",

    // Reset Store
    RESET_STORE: "RESET_STORE",

    // Send my profile
    FETCH_SEND_MY_PROFILE_REQUEST : 'FETCH_SEND_MY_PROFILE_REQUEST',
    FETCH_SEND_MY_PROFILE_SUCCESS : 'FETCH_SEND_MY_PROFILE_SUCCESS',
    FETCH_SEND_MY_PROFILE_FAILURE : 'FETCH_SEND_MY_PROFILE_FAILURE',
};
